<template>
    <header id="header">
        <div class="container">
            <b-button type="is-primary" class="button-add-new-task" @click="createNewTask()" v-if="!isEmptyList(workspaces)">
                <span>New Issue</span>
                <i class="fas fa-plus" style="margin-left: 8px;"></i>
            </b-button>

            <img 
                alt="Bugfer"
                src="/img/logo_dark.png"
                id="logo"
                @click="$router.push({name: 'home' })"/>

            <b-dropdown aria-role="list" class="workspace-dropdown-container hide" v-if="!isEmptyList(workspaces)">
                <button class="button" slot="trigger" v-if="workspace_selected">
                    <span>{{workspace_selected.name}}</span>
                    <i class="fas fa-angle-down" style="margin-left: 6px;"></i>
                </button>

                <template v-for="workspace in workspaces">
                    <b-dropdown-item v-if="workspace.id != workspace_selected.id" @click="_changeWorkspace(workspace.id)" :key="workspace.id">
                        {{workspace.name}}
                    </b-dropdown-item>
                </template>

                <b-dropdown-item separator></b-dropdown-item>
                <b-dropdown-item aria-role="listitem" @click="createNewProject()">
                    <i class="fas fa-tools" style="margin-right: 5px;"></i> Manage projects
                </b-dropdown-item>
                <b-dropdown-item aria-role="listitem" @click="createNewProject()">
                    <i class="fas fa-plus" style="margin-right: 5px;"></i> Create new project
                </b-dropdown-item>
            </b-dropdown>

            <div class="profile-settings-container">
                <img 
                    alt="Profile"
                    src="/img/profile_default.png"
                    id="profile-settings"
                    @click="$router.push({name: 'profile' })"/>
            </div>
        </div>
    </header>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getWorkspaces} from '../logic/workspace'
import ModalCreateTask from './ModalCreateTask'
import {createTask} from '../logic/task'
import {createLog} from '../logic/account'
import {isLogged, isEmptyList, getHeaders, getJWT} from '../logic/global'
import jwt_decode from 'jwt-decode'

let workspaces = []
let workspace_selected = {}

export default {
    name: 'Header',
    components: {},
    computed: mapGetters(["getWorkspaceId"]),
    data() {
        return {
            workspaces: workspaces,
            workspace_selected: workspace_selected
        }
    },
    methods: {
        ...mapActions(["changeWorkspace"]),
        isEmptyList: isEmptyList,
        _changeWorkspace: function(workspace_id){
            this.changeWorkspace(workspace_id);
            this.refreshSelectedWorkspace();
            window.location.reload();
        },
        refreshSelectedWorkspace: function(){
            for(let i = 0; i < this.workspaces.length; i++){
                if(this.workspaces[i].id == this.getWorkspaceId){
                    this.workspace_selected = this.workspaces[i]
                }
            }
        },
        createNewTask: function(){
            let _this = this;
            let token = jwt_decode(getJWT());
            _this.$modal.open({
                parent: this,
                component: ModalCreateTask,
                hasModalCard: true,
                props: {
                    workspaces: this.workspaces,
                    current_workspace: this.$route.params.workspace_id || null
                },
                events: {
                    'task_created': task_created => {
                        createTask(task_created["workspace_id"], task_created).then(response => {
                            window.location.reload();
                        }).catch(error => {
                            _this.showSuccessMsg("Something went wrong. Try again later or contact support.", "is-danger")
                            createLog({"entity": token["id"], "title": "Error creating", "content": JSON.stringify(error)})
                        })
                    }
                }
            })
        },
        showSuccessMsg: function(message, msg_type){
            this.$toast.open({message: message, type: msg_type})
        },
        createNewProject: function(){
            this.$router.push({name: "workspace_create"})
        }
    },
    mounted: function(){
        getWorkspaces().then(response => {
            this.workspaces = response.data.results
            this.refreshSelectedWorkspace();
        })
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    header{
        border-bottom: 1px solid #ebebeb;
        width: 100%;
        background: #fff;
    }
    #header >>> .dropdown-menu{
        padding-top: 0px;
        padding-bottom: 0px;
    }
    .button-add-new-task{
        position: absolute; top: 16px; left: 15px; text-transform: uppercase; font-size: 13px; height: 37px; padding-left: 15px; padding-right: 15px;
    }
    .workspace-dropdown-container{
        position: absolute;
        top: 18px;
        right: 75px;
    }
    .profile-settings-container{
        position: absolute;
        top: 10px;
        right: 10px;
        height: 50px;
        width: 50px;
        border-radius: 100%;
        overflow: hidden;
        cursor: pointer
    }
    #logo{
        width: auto;
        height: 30px;
        margin: 20px auto;
        display: block;
        cursor: pointer;
    }
</style>
